import React, { useEffect } from "react";
import { Container, Typography, Paper, Card, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import PageIntro from "../components/pageintro";
import SplitDescription from "../components/splitdescription";
import ServicesGridCards from "../components/servicesgrid";
import WhyTecloqCards from "../components/whytecloqcards";
import TransformComponent from "../components/transformcomp";
import GridCards from "../components/oddservicegrids";

const whydata = [
  {
    src: "/assets/AdvancedAI/PredictiveAnalysis/why1.gif",
    alt: "why1",
    title: "Domain Experience",
    description:
      "Our 7+ years of experience make us one of the best predictive analytics companies in US as we minimize risk, improve efficiency, and increase revenues with our highly customized solutions.",
  },
  {
    src: "/assets/AdvancedAI/PredictiveAnalysis/why2.png",
    alt: "why2",
    title: "Competitive Advantage",
    description:
      "We help you increase your competitive advantage. Predictive analytics consulting services help in better understanding customers, products, and partners, as well as identifying potential hazards and possibilities for a firm.",
  },
  {
    src: "/assets/AdvancedAI/PredictiveAnalysis/why3.png",
    alt: "why3",
    title: "Informed Decisions",
    description:
      "Our predictive analytics consulting services enable executives to make more informed business decisions. Construct decision models to plan for the best potential outcome using a variety of statistical analyses and algorithms.",
  },
];

const offeringdata = [
  {
    src: "/assets/AdvancedAI/PredictiveAnalysis/forcast.png",
    alt: "text analysis",
    width: "60%",
    paddingTop: "2%",
    text: "Forecasting Models",
    description:
      "Import and export data from office suites and other data-gathering channels to forecast future probabilities, and create predictive models.",
  },
  {
    src: "/assets/AdvancedAI/PredictiveAnalysis/entity.png",
    alt: "text analysis",
    width: "60%",
    paddingTop: "2%",
    text: "Entity Scoring",
    description:
      "Assign values to each Lead, Customer, and Product involved in your business in order of their respective priorities.",
  },
  {
    src: "/assets/AdvancedAI/PredictiveAnalysis/churn.png",
    alt: "text analysis",
    width: "60%",
    paddingTop: "2%",
    text: "Churn Prediction",
    description:
      "Anticipate which clients are most likely to terminate a subscription based on their previous behavior.",
  },
  {
    src: "/assets/AdvancedAI/PredictiveAnalysis/ptrends.png",
    alt: "text analysis",
    width: "60%",
    paddingTop: "2%",
    text: "Predict Trends",
    description:
      "Extract information from data sets to detect patterns and trends in order to forecast future outcomes.",
  },
  {
    src: "/assets/AdvancedAI/PredictiveAnalysis/future.png",
    alt: "text analysis",
    width: "60%",
    paddingTop: "2%",
    text: "Past to Future",
    description:
      "Predictive analytics solutions help businesses to go from a historical to a forward-looking customer viewpoint by utilizing big data (both stored and real-time).",
  },
];

const predictiveAnalysisData = [
  {
    src: "/assets/AdvancedAI/PredictiveAnalysis/forcast.png",
    alt: "Forecasting Models",
    title: "Forecasting Models",
    imgWidth: "60%",
    paddingTop: "2%",
    description:
      "Import and export data from office suites and other data-gathering channels to forecast future probabilities, and create predictive models.",
  },
  {
    src: "/assets/AdvancedAI/PredictiveAnalysis/entity.png",
    alt: "Entity Scoring",
    title: "Entity Scoring",
    imgWidth: "60%",
    paddingTop: "2%",
    description:
      "Assign values to each Lead, Customer, and Product involved in your business in order of their respective priorities.",
  },
  {
    src: "/assets/AdvancedAI/PredictiveAnalysis/churn.png",
    alt: "Churn Prediction",
    title: "Churn Prediction",
    imgWidth: "60%",
    paddingTop: "2%",
    description:
      "Anticipate which clients are most likely to terminate a subscription based on their previous behavior.",
  },
  {
    src: "/assets/AdvancedAI/PredictiveAnalysis/ptrends.png",
    alt: "Predict Trends",
    title: "Predict Trends",
    imgWidth: "60%",
    paddingTop: "2%",
    description:
      "Extract information from data sets to detect patterns and trends in order to forecast future outcomes.",
  },
  {
    src: "/assets/AdvancedAI/PredictiveAnalysis/future.png",
    alt: "Past to Future",
    title: "Past to Future",
    imgWidth: "60%",
    paddingTop: "2%",
    description:
      "Predictive analytics solutions help businesses to go from a historical to a forward-looking customer viewpoint by utilizing big data (both stored and real-time).",
  },
];



const AIPredictiveAnalysis = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflowX: "hidden" }}>
      <PageIntro
        bg={"/assets/AdvancedAI/PredictiveAnalysis/background.webp"}
        subheading={
          "Refine data sources to find hidden values in uncovered patterns!"
        }
        heading={"Predictive Analytics Consulting Services"}
        desc={
          "Stay one step ahead with Tecloq, one of the best predictive analytics companies in US"
        }
      />

      <SplitDescription
        heading1={"Anticipating Trends and Preferences"}
        heading2={"Hand-Holding by our Experts"}
        content1={`The ever-increasing volume and types of data coupled with the interest to derive valuable insights to optimize operations, reduce risks, and increase revenue are encouraging organizations across the industries to use predictive analytics. By using advanced analytics like statistical algorithms, text analytics, machine learning, predictive modeling, real-time scoring, and data mining – organizations are anticipating future trends and customer preferences to take strategic business decisions.​`}
        content2={`Working with predictive models necessitates an understanding of big data, artificial intelligence, and machine learning. Predictive analytics is a time-consuming and complex process that should be left to analytics and data science experts. Our experts guide you through the process and create datasets and/or data visualizations from compiled data by mining and analyzing structured and/or unstructured data.`}
        img1={"/assets/AdvancedAI/PredictiveAnalysis/trends.png"}
        img2={"/assets/AdvancedAI/PredictiveAnalysis/holdings.webp"}
      />

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          margin: { xs: "5% 5% 0 5%", md: "5% 15% 0 15%" }, // Adjust margins based on screen size
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" }, // Smaller font size on mobile
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "3%",
            textAlign: "center", // Center align on all screens
          }}
        >
          Our Offerings
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: { xs: "14px", md: "20px" }, // Adjust font size for mobile
            fontWeight: "lighter",
            color: "#000000",
            textAlign: "center",
            marginBottom: { xs: "8%", md: "5%" }, // Larger margin on mobile for better spacing
          }}
        >
          Choosing tecloq as your Data Analytics Services partner means
          embracing a holistic approach to data-driven decision-making. We stand
          out for several reasons.
        </Typography>
      </Box>

      {/* <ServicesGridCards data={offeringdata} /> */}
      <GridCards data={predictiveAnalysisData} cardWidth={"375px"}/>

      {/* <Box
                sx={{
                    display: 'flex',
                    justifyContent:"center",
                    flexWrap: 'wrap',
                    '& > :not(style)': {
                    m: 1,
                    width: 375,
                    height: 450,
                    },
                    gap:"20px",
                }}
                >
                <Paper elevation={3} sx={{borderRadius:"5%", textAlign:"center", paddingTop:"2%", border:"0.5px solid #FFC3EA", boxShadow:"0px -3px 17px rgba(240, 5, 162, 0.52)"}}>
                    <img 
                    src='/assets/AdvancedAI/PredictiveAnalysis/forcast.png'
                    alt='text analysis'
                    style={{boxSizing:"border-box", width:"60%", height:"auto"}}
                    loading='lazy'
                    >
                    </img>
                    <Typography style={{fontFamily:"Orbitron", fontStyle:"normal", fontWeight:"700",
                    fontSize:"25px", lineHeight:"120%", alignItems:"center", textAlign:"center",
                    color:"#F005A2", paddingTop:"10%", letterSpacing:"2%"}}
                    >Forecasting Models</Typography>
                    <Typography style={{fontFamily:"Inter", fontStyle:"normal", fontSize:"16px", fontWeight:"lighter", textAlign:"center", padding:"10% 12% 1% 12%"}}>
                    Import and export data from office suites and other data-gathering channels to forecast future probabilities, and create predictive models.</Typography>
                </Paper>
                <Paper elevation={3} sx={{borderRadius:"5%", textAlign:"center", paddingTop:"2%", border:"0.5px solid #FFC3EA", boxShadow:"0px -3px 17px rgba(240, 5, 162, 0.52)"}}>
                    <img 
                    src='/assets/AdvancedAI/PredictiveAnalysis/entity.png'
                    alt='text analysis'
                    loading='lazy'
                    style={{boxSizing:"border-box", width:"60%", height:"auto"}}
                    >
                    </img>
                    <Typography style={{fontFamily:"Orbitron", fontStyle:"normal", fontWeight:"700",
                    fontSize:"25px", lineHeight:"120%", alignItems:"center", textAlign:"center",
                    color:"#F005A2", paddingTop:"10%", letterSpacing:"2%"}}
                    >Entity Scoring</Typography>
                    <Typography style={{fontFamily:"Inter", fontStyle:"normal", fontSize:"16px", fontWeight:"lighter", textAlign:"center", padding:"10% 12% 1% 12%"}}>
                    Assign values to each Lead, Customer, and Product involved in your business in order of their respective priorities.</Typography>
                </Paper>
                <Paper elevation={3} sx={{borderRadius:"5%", textAlign:"center", paddingTop:"2%", border:"0.5px solid #FFC3EA", boxShadow:"0px -3px 17px rgba(240, 5, 162, 0.52)"}}>
                    <img 
                    src='/assets/AdvancedAI/PredictiveAnalysis/churn.png'
                    alt='text analysis'
                    style={{boxSizing:"border-box", width:"60%", height:"auto"}}
                    loading='lazy'
                    >
                    </img>
                    <Typography style={{fontFamily:"Orbitron", fontStyle:"normal", fontWeight:"700",
                    fontSize:"25px", lineHeight:"120%", alignItems:"center", textAlign:"center",
                    color:"#F005A2", paddingTop:"10%", letterSpacing:"2%"}}
                    >Churn Prediction</Typography>
                    <Typography style={{fontFamily:"Inter", fontStyle:"normal", fontSize:"16px", fontWeight:"lighter", textAlign:"center", padding:"10% 12% 1% 12%"}}>
                    Anticipate which clients are most likely to terminate a subscription based on their previous behavior.</Typography>
                </Paper>
                <Paper elevation={3} sx={{borderRadius:"5%", textAlign:"center", paddingTop:"2%", border:"0.5px solid #FFC3EA", boxShadow:"0px -3px 17px rgba(240, 5, 162, 0.52)"}}>
                    <img 
                    src='/assets/AdvancedAI/PredictiveAnalysis/ptrends.png'
                    alt='text analysis'
                    style={{boxSizing:"border-box", width:"60%", height:"auto"}}
                    loading='lazy'
                    >
                    </img>
                    <Typography style={{fontFamily:"Orbitron", fontStyle:"normal", fontWeight:"700",
                    fontSize:"25px", lineHeight:"120%", alignItems:"center", textAlign:"center",
                    color:"#F005A2", paddingTop:"10%", letterSpacing:"2%"}}
                    >Predict Trends</Typography>
                    <Typography style={{fontFamily:"Inter", fontStyle:"normal", fontSize:"16px", fontWeight:"lighter", textAlign:"center", padding:"10% 12% 1% 12%"}}>
                    Extract information from data sets to detect patterns and trends in order to forecast future outcomes.</Typography>
                </Paper>
                <Paper elevation={3} sx={{borderRadius:"5%", textAlign:"center", paddingTop:"2%", border:"0.5px solid #FFC3EA", boxShadow:"0px -3px 17px rgba(240, 5, 162, 0.52)"}}>
                    <img 
                    src='/assets/AdvancedAI/PredictiveAnalysis/future.png'
                    loading='lazy'
                    alt='text analysis'
                    style={{boxSizing:"border-box", width:"60%", height:"auto"}}
                    >
                    </img>
                    <Typography style={{fontFamily:"Orbitron", fontStyle:"normal", fontWeight:"700",
                    fontSize:"25px", lineHeight:"120%", alignItems:"center", textAlign:"center",
                    color:"#F005A2", paddingTop:"10%", letterSpacing:"2%"}}
                    >Past to Future</Typography>
                    <Typography style={{fontFamily:"Inter", fontStyle:"normal", fontSize:"16px", fontWeight:"lighter", textAlign:"center", padding:"10% 12% 1% 12%"}}>
                    Predictive analytics solutions help businesses to go from a historical to a forward-looking customer viewpoint by utilizing big data (both stored and real-time).</Typography>
                </Paper>
            </Box> */}
      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "4%", md: "6%" }, // Smaller margin on mobile
          paddingX: { xs: "5%", sm: "10%", md: "15%" }, // Responsive padding
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "1%",
            textAlign: "center",
          }}
        >
          Why Tecloq?
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "14px", sm: "18px", md: "20px" }, // Responsive font size
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            margin: { xs: "2% 5%", sm: "1% 10%", md: "1% 15%" }, // Responsive margin
          }}
        >
          Tecloq is a leading text analytics company in the US, offering
          cost-effective text analytics solutions to businesses of all sizes.
          Our custom text analytics services and solutions are designed to aid
          our clients in improving their customer experience through product
          integration. Our Text Analytics Services will help in the development
          of better products based on customer feedback, as well as the
          optimization of business operations.
        </Typography>
      </Box>

      <WhyTecloqCards data={whydata} />
      <TransformComponent />
    </Box>
  );
};

export default AIPredictiveAnalysis;
